<template>
  <v-row>
    <v-col cols="12" sm="6" class="pr-3">
      <v-autocomplete
        :items="items"
        item-text="name"
        outlined
        hide-details
        dense
        small-chips
        item-value="id"
        :value="value[inputItem]"
        @input="onInputItem"
        required
      />
    </v-col>
    <v-col cols="12" sm="6">
      <v-text-field
        label="Date"
        dense
        hide-details
        outlined
        :value="value[inputDate]"
        @input="$emit('input', { ...value, [inputDate]: $event })"
        type="datetime-local"
        min="2010-06-07T00:00"
      ></v-text-field>
    </v-col>
  </v-row>
</template>
<script>
import { generateMessage } from '@/utils/i18n';
import { mapState } from 'vuex';
import { getCurrentLocalDateTime } from '@/business/utils/dates';

export default {
  name: 'custom-date-item-selector',
  props: {
    inputDate: { type: String, default: 'date' },
    inputItem: { type: String, default: 'item' },
    namespace: { type: String, required: true },
    value: { type: Object, required: true },
  },
  computed: {
    ...mapState({
      items(state, getters) {
        return getters[`${this.namespace}/items`];
      },
    }),
  },
  methods: {
    generateMessage,
    getCurrentLocalDateTime,
    onInputItem(value) {
      this.$emit('input', {
        ...this.value,
        [this.inputItem]: value,
        [this.inputDate]:
          value !== this.value[this.inputItem]
            ? this.getCurrentLocalDateTime()
            : this.value[this.inputDate],
      });
    },
  },
};
</script>
